import { render, staticRenderFns } from "./EmailConfirmationError.vue?vue&type=template&id=bf5ec0c6"
import script from "./EmailConfirmationError.vue?vue&type=script&lang=js"
export * from "./EmailConfirmationError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports